module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-left-text-49926d0e.svg";